import { useEffect, useRef } from "react";
import cloudinary from "cloudinary-video-player";
import "cloudinary-video-player/chapters";
import "cloudinary-video-player/cld-video-player.min.css";
import { PlayerWrapper } from "./styled";

const VideoPlayer = ({
  src,
  captions,
  subtitles,
  chaptersUrl,
  onPlayButtonClick,
  ...props
}) => {
  const cloudinaryRef = useRef();
  const playerRef = useRef();

  useEffect(() => {
    if (cloudinaryRef.current) return;

    cloudinaryRef.current = cloudinary;

    const player = cloudinaryRef.current.videoPlayer(playerRef.current, {
      secure: true,
      showCaptionsButton: captions || subtitles,
      textTrackSettings: true,
      controls: true,
      showLogo: false,
      hideContextMenu: true,
      pictureInPictureToggle: true,
      playbackRates: [2, 1.75, 1.5, 1.25, 1, 0.75, 0.5, 0.25],
      fill: true,
    });

    const textTracks = {};
    if (captions) {
      textTracks.captions = captions;
    }
    if (subtitles) {
      textTracks.subtitles = subtitles;
    }

    // Configure source
    player.source(src, {
      sourceTypes: ["mp4"],
      chapters: chaptersUrl && {
        url: chaptersUrl,
      },
      textTracks,
    });

    if (onPlayButtonClick) {
      player.on("play", onPlayButtonClick);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PlayerWrapper>
      <video
        ref={playerRef}
        data-testid="cloudinary-video-player"
        className="cld-video-player"
        {...props}
      />
    </PlayerWrapper>
  );
};

export default VideoPlayer;
